import {RouteProps} from '../../../routes/AppRouter'
import {URL_PATIENTS_PGD} from '../../../routes/routes-constants'
import {PatientPGD} from 'modules/patients/models/PatientPGD'
import {Forms} from 'features/common/pgd-pg-common/Form'

export type FormProps = RouteProps & {
    patient: PatientPGD | undefined
}

export const Form = (props: FormProps) => {
  return <Forms patient={props.patient} pgType='pgd' urlPatinet={URL_PATIENTS_PGD}/>
}
